import type { SearchResultType } from './types';

export const SEARCH_RESULT_TYPES: SearchResultType[] = ['submissions', 'templates', 'blocks', 'clauses'];

export const TYPE_LABELS: Record<SearchResultType, string> = {
  submissions: 'Contracts',
  templates: 'Templates',
  blocks: 'Blocks',
  clauses: 'Clauses',
};

export const TYPE_TOOLTIPS: Record<SearchResultType, string> = {
  submissions: 'Contract',
  templates: 'Template',
  blocks: 'Block',
  clauses: 'Clause',
};

export const FILTER_OPTIONS: { label: string; value: SearchResultType }[] = SEARCH_RESULT_TYPES.map((value) => ({
  label: TYPE_LABELS[value],
  value,
}));

export const PALETTE_RESULTS_SIZE = 50;
export const MIN_QUERY_LENGTH = 2;
export const MAX_QUERY_LENGTH = 100;
export const SEARCH_DEBOUNCE_MS = 250;
export const MAX_RECENT_ITEMS = 5;
export const MAX_HIGHLIGHTS_PER_RESULT = 2;
